import { render, staticRenderFns } from "./enclosureComponents.vue?vue&type=template&id=36849180&scoped=true&"
import script from "./enclosureComponents.vue?vue&type=script&lang=js&"
export * from "./enclosureComponents.vue?vue&type=script&lang=js&"
import style0 from "./enclosureComponents.vue?vue&type=style&index=0&id=36849180&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36849180",
  null
  
)

export default component.exports